import React from 'react';
import classnames from 'classnames';
import { Render, WorkshopServiceRating, WorkshopServiceRatingProperty } from 'types';
import { formatLabelFromProperty } from 'util/index';
import { AdminContentWrapper } from 'components/AdminContent';
import { useFormField, useWorkshopServiceRatingField } from 'types/formik';

function EditField(
  props: Readonly<{
    label?: string;
    property: WorkshopServiceRatingProperty;
    itemIndex: number;
    workshopServiceRating?: WorkshopServiceRating;
  }>
): Render {
  const [{ value: indexServiceRating }, { touched, error }, { setValue: setServiceRating }] =
    useWorkshopServiceRatingField(props.itemIndex);
  const fieldName = 'serviceRatingExcludeForTowers';
  const hasError = touched && error;

  const [{ value: workshop }] = useFormField('workshop');
  const value = workshop?.excludeForTowers ? true : indexServiceRating?.excludeForTowers;

  return (
    <div className='if form-group component workshop-field checkbox'>
      <div className='if checkbox'>
        <input
          checked={value}
          disabled={workshop?.excludeForTowers}
          onChange={() => {
            setServiceRating({
              ...indexServiceRating,
              excludeForTowers: !value,
            });
          }}
          type='checkbox'
          className={classnames('if checkbox-input', hasError && 'is-invalid')}
          data-cy={fieldName}
        />
        <label
          className='if label'
          onClick={() => {
            if (!workshop?.excludeForTowers) {
              setServiceRating({
                ...indexServiceRating,
                excludeForTowers: !value,
              });
            }
          }}
        >
          {props.label ?? formatLabelFromProperty(props.property)}
        </label>
        {hasError && <div className='if input-error'>{error}</div>}
      </div>
    </div>
  );
}
const editField = AdminContentWrapper(EditField);

const ReadField = (props: {
  label?: string;
  property: WorkshopServiceRatingProperty;
  workshopServiceRating?: WorkshopServiceRating;
}): Render => {
  const [{ value: workshop }] = useFormField('workshop');
  const excludeServiceForTowing = props.workshopServiceRating?.excludeForTowers;
  const value = workshop?.excludeForTowers ? true : excludeServiceForTowing;

  return (
    <div className={classnames('component field checkbox-container')}>
      <div className='if label'>{props.label ?? formatLabelFromProperty(props.property)}</div>
      <div data-cy={'WorkshopServiceRating.' + props.property}>{value ? <>Yes</> : <>No</>}</div>
    </div>
  );
};

export function ServiceRatingCheckbox(editing: boolean) {
  return editing ? editField : ReadField;
}
